/* eslint-disable prefer-const */
const braze = require('@braze/web-sdk')

export default (context, inject, event) => {
  // Determine the environment channel
  const activeEnvChannel =
    event && event.headers && event.headers.client_sub === 'catering'
      ? '26df2700-b484-46d6-8f7d-35c2704d5ff0'
      : process.env.BRAZE_SDK_KEY
  const activeChannel =
    event && event.headers && event.headers.client_sub === 'catering'
      ? 'catering'
      : 'mealtime'

  braze.initialize(activeEnvChannel, {
    baseUrl: process.env.BRAZE_SDK_ENDPOINT,
    enableLogging: process.env.BRAZE_LOGGING === 'true',
    allowUserSuppliedJavascript: true,
    minimumIntervalBetweenTriggerActionsInSeconds: 1
  })

  // Subscribe and filter In-App Messages
  braze.subscribeToInAppMessage(function(inAppMessage) {
    // Control group messages should always be "shown"
    // this will log an impression and not show a visible message
    if (inAppMessage.isControl) {
      return braze.showInAppMessage(inAppMessage)
    }

    // Custom filtering logic using extras
    if (inAppMessage instanceof braze.InAppMessage) {
      const extras = inAppMessage.extras
      if (extras && Object.keys(extras).length > 0) {
        for (const key in extras) {
          // console.log('IAM extra key: ' + key + ', value: ' + extras[key])

          // Only show catering IAMs on catering
          if (extras[key] === 'iam_catering') {
            if (activeChannel && activeChannel === 'catering') {
              return braze.showInAppMessage(inAppMessage)
            }
          }
          // Only show mealtime IAMs on non-catering
          else if (extras[key] === 'iam_mealtime') {
            if (activeChannel && activeChannel === 'mealtime') {
              return braze.showInAppMessage(inAppMessage)
            }
          }
          // Never show iam_app messages on web
          else if (extras[key] === 'iam_app') {
            return // do nothing, skip showing
          }
        }
      } else {
        // No extras present → show on all channels
        return braze.showInAppMessage(inAppMessage)
      }
    }
    // If no extras matched, do nothing (message won't show)
  })

  // When the user logs in or a Refresh is called our callback will sort and return the cards
  braze.subscribeToContentCardsUpdates((updates) => {
    // Arrays for cached or refreshed cards
    let _homepageCarouselCards = []
    let _homepageTopAlertCards = []
    let _offerScreenMessageCard = []

    const cards = updates.cards
    // console.log('Cards before Sort', cards)

    cards.forEach((card) => {
      if (card.isControl) {
        // Do not display the control card, but remember to call `logContentCardImpressions([card])`
      } else if (card.extras && card.extras.feed_type) {
        if (activeChannel && activeChannel === 'catering') {
          // catering channel, only show catering cards
          if (
            card.extras.feed_type === 'homepage_carousel' ||
            card.extras.feed_type === 'homepage_carousel_web'
          ) {
            _homepageCarouselCards.push(card)
          } else if (
            card.extras.feed_type === 'homepage_top_alert_catering' ||
            card.extras.feed_type === 'homepage_top_alert_catering_web'
          ) {
            _homepageTopAlertCards.push(card)
          } else if (
            card.extras.feed_type === 'offer_screen_message_catering' ||
            card.extras.feed_type === 'offer_screen_message_catering_web'
          ) {
            _offerScreenMessageCard.push(card)
          } else if (
            card.extras.feed_type === 'order_checkout_card_catering' ||
            card.extras.feed_type === 'order_checkout_card_catering_web'
          ) {
            // Do nothing, not currently implemented on the front end
          }
        } else {
          // default channel, only show default cards
          // eslint-disable-next-line no-lonely-if
          if (
            card.extras.feed_type === 'homepage_carousel' ||
            card.extras.feed_type === 'homepage_carousel_web'
          ) {
            _homepageCarouselCards.push(card)
          } else if (
            card.extras.feed_type === 'homepage_top_alert' ||
            card.extras.feed_type === 'homepage_top_alert_bo' ||
            card.extras.feed_type === 'homepage_top_alert_bo_web'
          ) {
            _homepageTopAlertCards.push(card)
          } else if (
            card.extras.feed_type === 'offer_screen_message' ||
            card.extras.feed_type === 'offer_screen_message_bo' ||
            card.extras.feed_type === 'offer_screen_message_bo_web'
          ) {
            _offerScreenMessageCard.push(card)
          } else if (
            card.extras.feed_type === 'order_checkout_card_bo' ||
            card.extras.feed_type === 'order_checkout_card_bo_web'
          ) {
            // Do nothing, not currently implemented on the front end
          } else {
            // do nothing, skip showing
          }
        }
      } else {
        // No extras present → display everywhere (default bucket)
        _homepageCarouselCards.push(card)
      }
    })

    context.store.commit('setHomepageCarouselContentCards', [
      ...homepageCarouselCards
    ])
    context.store.commit('setHomepageTopAlertContentCards', [
      ..._homepageTopAlertCards
    ])
    context.store.commit('setOfferScreenContentCards', [
      ..._offerScreenMessageCard
    ])
  })

  // Arrays for cached or refreshed cards
  let homepageCarouselCards = []
  let homepageTopAlertCards = []
  let offerScreenMessageCards = []

  // Sort cached cards into arrays for usage by components
  braze.getCachedContentCards().cards.forEach((card) => {
    if (card.isControl) {
      // Do not display the control card, but remember to call `logContentCardImpressions([card])`
    } else if (card.extras && card.extras.feed_type) {
      if (activeChannel && activeChannel === 'catering') {
        // catering channel, only show catering cards
        if (
          card.extras.feed_type === 'homepage_carousel_catering' ||
          card.extras.feed_type === 'homepage_carousel_catering_web'
        ) {
          homepageCarouselCards.push(card)
        } else if (card.extras.feed_type === 'homepage_top_alert_catering') {
          homepageTopAlertCards.push(card)
        } else if (card.extras.feed_type === 'offer_screen_message_catering') {
          offerScreenMessageCards.push(card)
        } else if (
          card.extras.feed_type === 'order_checkout_card_catering' ||
          card.extras.feed_type === 'order_checkout_card_catering_web'
        ) {
          // Do nothing, not currently implemented on the front end
        }
      } else {
        // default channel, only show default cards
        // eslint-disable-next-line no-lonely-if
        if (
          card.extras.feed_type === 'homepage_carousel' ||
          card.extras.feed_type === 'homepage_carousel_web'
        ) {
          homepageCarouselCards.push(card)
        } else if (card.extras.feed_type === 'homepage_top_alert') {
          homepageTopAlertCards.push(card)
        } else if (card.extras.feed_type === 'offer_screen_message') {
          offerScreenMessageCards.push(card)
        } else if (
          card.extras.feed_type === 'order_checkout_card_bo' ||
          card.extras.feed_type === 'order_checkout_card_bo_web'
        ) {
          // Do nothing, not currently implemented on the front end
        } else {
          // do nothing, skip showing
        }
      }
    } else {
      // No extras present display everywhere (default bucket)
      homepageCarouselCards.push(card)
    }
  })

  // Set store cards to sorted card arrays
  context.store.commit('setHomepageCarouselContentCards', [
    ...homepageCarouselCards
  ])
  context.store.commit('setHomepageTopAlertContentCards', [
    ...homepageTopAlertCards
  ])
  context.store.commit('setOfferScreenContentCards', [
    ...offerScreenMessageCards
  ])

  // console.log('Store', context.store)
  // Always run last, after initial configuration is completed
  // Start session for anonymous users
  braze.openSession()

  inject('braze', braze)
  context.$braze = braze
}
